interface SanitizeNumericInputOptions {
  allowCurrencyPrefix?: boolean;
  allowUnitSuffix?: boolean;
}

const normalizeLeadingZeros = (value: string): string => {
  if (!value || value === "." || !value.startsWith("0")) {
    return value;
  }

  if (value.includes(".")) {
    const [wholePart, fractionalPart] = value.split(".");

    if (!wholePart) {
      return value;
    }

    const normalizedWholePart = wholePart.replace(/^0+(?=\d)/, "");
    return `${normalizedWholePart}.${fractionalPart ?? ""}`;
  }

  return value.length > 1 ? `0.${value.slice(1)}` : value;
};

export const sanitizeNumericInput = (
  rawValue: string,
  { allowCurrencyPrefix = false, allowUnitSuffix = false }: SanitizeNumericInputOptions = {},
): string => {
  const hasLeadingCurrency = allowCurrencyPrefix && rawValue.startsWith("$");
  let filteredValue: string;

  if (allowUnitSuffix) {
    filteredValue = rawValue.replace(
      allowCurrencyPrefix ? /[^\d.$a-zA-Z\s]/g : /[^\d.a-zA-Z\s]/g,
      "",
    );
  } else if (allowCurrencyPrefix) {
    filteredValue = rawValue.replace(/[^\d.$]/g, "");
  } else {
    filteredValue = rawValue.replace(/[^\d.]/g, "");
  }
  const unitSuffix = allowUnitSuffix ? filteredValue.replace(/[\d.$\s]/g, "") : "";
  const valueWithoutCurrency = filteredValue.replace(/[a-zA-Z\s]/g, "").replace(/\$/g, "");
  const [wholePart, ...decimalParts] = valueWithoutCurrency.split(".");
  const firstDotPreserved =
    decimalParts.length > 0 ? `${wholePart}.${decimalParts.join("")}` : wholePart;
  const normalizedValue = normalizeLeadingZeros(firstDotPreserved);

  if (allowCurrencyPrefix && normalizedValue === ".") {
    return "$0.";
  }

  if (normalizedValue === ".") {
    return "0.";
  }

  if (allowCurrencyPrefix) {
    if (normalizedValue) {
      return `$${normalizedValue}${unitSuffix}`;
    }

    if (hasLeadingCurrency) {
      return "$";
    }
  }

  return normalizedValue ? `${normalizedValue}${unitSuffix}` : "";
};
